import type { ShowcaseType } from '~/composables/useShowcase'

/**
 * Shared state that lets the bottom-nav "Add" button drive the global
 * `ShowcaseComposer` (create a media post) and notify the visible profile
 * showcase to reload after a post is created.
 */
export function useShowcaseComposer() {
  // Bumped to request the composer open the media picker for `targetType`.
  const openRequest = useState<number>('showcase-composer-open', () => 0)
  const targetType = useState<ShowcaseType>('showcase-composer-type', () => 'seeker')
  // Bumped after a post is successfully created, so open showcases can reload.
  const refreshToken = useState<number>('showcase-refresh', () => 0)

  function requestOpen(type: ShowcaseType) {
    targetType.value = type
    openRequest.value++
  }

  function notifyPosted() {
    refreshToken.value++
  }

  return { openRequest, targetType, refreshToken, requestOpen, notifyPosted }
}
